import request from '../request'

// 理赔申请的基本信息 ，上传文件类型
const getcalimAppBaseIfo = (data) => {
  return request.post('/api/wx/auth/calimApp/getcalimAppBaseIfo', data)
}
// 调查问卷保存（弹窗取消的时候也会调用）
const saveIsQuestionnaire = (data) => {
  return request.post('/api/wx/auth/saveIsQuestionnaire', data)
}
// 判断当前保险卡是否已经领取微信会员卡
const isExistsCard = (data) => {
  return request.post('/api/wx/isExistsCard', data)
}
// 前端用户点击领卡时同时向后台存一条领取信息
const addCardInfo = (data) => {
  return request.post('/api/wx/addCardInfo', data)
}
// 获取卡包jsDk
const getWxCardJsJdkSign = (data) => {
  return request.post('/api/wx/getJsJdkSign', data)
}
// 查询是否领取过勋章
const getYlAccountFlag = (data) => {
  return request.post('/api/wx/auth/getYlAccountFlag', data)
}
// 更新是否领取过勋章的状态
const updateYlAccountFlag = (data) => {
  return request.post('/api/wx/auth/updateYlAccountFlag', data)
}
// 对象数组
export default {
  getcalimAppBaseIfo,
  saveIsQuestionnaire,
  isExistsCard,
  addCardInfo,
  getWxCardJsJdkSign,
  getYlAccountFlag,
  updateYlAccountFlag
}
